import * as React from "react";

import { Button } from "semantic-ui-react";

import { CaseType } from "@teamprevent/common/model";

import { LinkedOhCase } from "../model";

import { Link } from "redux-little-router";

export const LinkedCaseButton: React.FunctionComponent<{ customerId: string; employeeRecordId: string; linkedCase: LinkedOhCase }> = (props) => {
    let buttonText: string;
    switch (props.linkedCase.caseType) {
        case CaseType.PPQ:
            buttonText = "View PPQ Case";
            break;
        case CaseType.IMMUNISATION:
            buttonText = "View Immunisation Case";
            break;
        case CaseType.BBV:
            buttonText = "View BBV Case";
            break;
        case CaseType.HEALTH_SURVEILLANCE:
            buttonText = "View Health Surveillance/Fit for Work Case";
            break;
        case CaseType.REFERRAL:
            buttonText = "View Referral Case";
            break;
        case CaseType.PHYSIOTHERAPY_REFERRAL:
            buttonText = "View Physiotherapy Referral Case";
            break;
        case CaseType.WORK_ADJUSTMENT:
            buttonText = `View Work Adjustment Case ${props.linkedCase.caseId}`;
            break;
        case CaseType.MHP_TREATMENT:
            buttonText = "View MHP Case";
            break;
        default:
            buttonText = "View Case";
            break;
    }

    return (
        <Link href={`/customers/${props.customerId}/employeeRecords/${props.employeeRecordId}/ohCases/${props.linkedCase.id}`} target="_blank">
            <Button content={buttonText} />
        </Link>
    );
};
